import Mock, { Random } from 'mockjs';
import MockRequest, { AjaxDate } from '../MockRequest';

export function queryQuestionList(data: AjaxDate) {
  console.log(data);
  return new MockRequest(
    Mock.mock(
      {
        [`data|${Random.integer(0, 20)}`]: [{
          analysis: '@cword(2,300)',
          answer: '[]',
          assignmentId: '作业Id',
          id: '@guid',
          metas: JSON.stringify(['A选项内容', 'B选项内容', 'C选项内容']),
          moduleId: '@guid',
          questionType: '@integer(0,3)',
          score: '@integer(1,10)',
          seq: '@integer(1,10)',
          stem: '@cword(100,300)',
        }],
      },
    ), '请求成功', true,
  );
}

export function delQuestion(data: AjaxDate) {
  const { ids } = JSON.parse(data.body);
  return new MockRequest(
    ids, '删除成功', true,
  );
}

export function test() { return {}; }
